export class Setting {
  constructor(
    public hash?: string,
    public description?: string,
    public value?: string,
    public name?: string
  ) { }

  clone() {
    return new Setting(
      this.hash,
      this.description,
      this.value,
      this.name
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/setting.ts